// could we create this from the path constants file?
export const SAVED_VIEW_NAMESPACE = "/agent/contacts";
